"use client";

import React, { useState } from "react";

const faqItems = [
  {
    question: "What is Eyam Discover?",
    answer: "Discover is Eyam's business directory. Find local businesses and service providers, view their profiles, explore services and specials, and use the available contact or booking options.",
  },
  {
    question: "How do I find a business near me?",
    answer: "Search for a business name, service or keyword and enter your city, suburb or area. On Discover, you can also browse industries and refine your search to find a business that suits your needs.",
  },
  {
    question: "Do I need an account to browse Discover?",
    answer: "You can browse business profiles without signing in. To follow a business and manage the places you follow, you need to sign in or create an Eyam account.",
  },
  {
    question: "Can I book a service through a business profile?",
    answer: "When a business has enabled services and booking availability, you can choose a service and request a time on its profile. Your request is subject to the business accepting it; submitting a request does not automatically confirm the appointment.",
  },
  {
    question: "Where can I see discounts and special offers?",
    answer: "Current offers appear in the business profile's specials section. Check each offer's dates, discount label, promo code and terms. Contact the business if you need clarification before using an offer.",
  },
  {
    question: "What happens when I follow a business?",
    answer: "Following adds the business to Places you follow and lets you receive email updates about new or updated services and active specials. Before you follow, a popup explains the information sharing and email updates, and you can choose Follow or Cancel.",
  },
  {
    question: "What information is shared with a business I follow?",
    answer: "Your account name and email address are shared with the business in its followers list. Following does not share your password, payment details or other account information. Cancel the follow popup if you do not want to share your name and email.",
  },
  {
    question: "How do I stop receiving updates from a business?",
    answer: "Sign in and open Places you follow from Discover, or open the business profile. Choose Unfollow to stop future updates and remove your name and email from its current followers list. Emails already delivered cannot be recalled.",
  },
  {
    question: "Do I need a domain name or hosting for my Discover profile?",
    answer: "Your Discover profile is hosted on Eyam and has its own shareable business link. You do not need to arrange separate domain registration or website hosting for that profile.",
  },
  {
    question: "Can I update my business details, services and photos later?",
    answer: "Yes. Sign in as the business owner and open your listing manager to edit your business information, operating hours, services and gallery. You can also manage discounts and specials and view the customers who agreed to follow your business. Published contact options and gallery limits depend on your subscription.",
  },
  {
    question: "How do I share a business profile on WhatsApp?",
    answer: "Use Share on the business profile and choose WhatsApp when it is available on your device. The message introduces the business, explains that people can contact it or make a booking, and includes its profile link. If your device does not offer sharing, copy the message and paste it into WhatsApp.",
  },
  {
    question: "How do campaigns work on Eyam?",
    answer:
      "Campaigns connect companies and creators. A company creates a campaign, creators join it, publish qualifying content, and performance is tracked so payouts can be calculated.",
  },
  {
    question: "How much can I earn from campaigns?",
    answer:
      "On qualifying campaign content, promoters can earn R20 per 1,000 views. High-performing content can also unlock bonus rewards depending on campaign rules and results.",
  },
  {
    question: "Why should my business list on Discovery?",
    answer:
      "A Discovery listing helps people find your business by category, location, and search terms. You can showcase your profile, contact details, socials, and services in one place.",
  },
  {
    question: "Can I both run campaigns and list on Discovery?",
    answer:
      "Yes. Businesses can launch campaigns to get promoter content and also maintain a Discovery listing to improve long-term visibility and lead generation.",
  },
];

const HomeFaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="container pb-16 pt-8 md:pb-24" aria-labelledby="home-faq-heading">
      <div className="mx-auto max-w-4xl">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.16em] text-[#72C7DA]">
          Help Center
        </p>
        <h2
          id="home-faq-heading"
          className="mt-3 text-center text-2xl font-bold text-[#1F205A] dark:text-white md:text-4xl"
        >
          Frequently Asked Questions
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-slate-600 dark:text-slate-300 md:text-base">
          Find answers about discovering businesses, bookings, specials, following and campaigns.
        </p>

        <div className="mt-8 space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.question}
                className="rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={`home-faq-answer-${index}`}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-[#1F205A] dark:text-white md:text-base">
                    {item.question}
                  </span>
                  <span
                    className={`inline-block text-xl text-[#1F205A] transition-transform dark:text-[#72C7DA] ${
                      isOpen ? "rotate-45" : "rotate-0"
                    }`}
                    aria-hidden="true"
                  >
                    +
                  </span>
                </button>
                {isOpen && (
                  <div id={`home-faq-answer-${index}`} className="border-t border-slate-100 px-5 py-4 text-sm leading-relaxed text-slate-600 dark:border-slate-700 dark:text-slate-300">
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeFaq;
